import { render, staticRenderFns } from "./DispatchJobs.vue?vue&type=template&id=8cbaed7a&"
import script from "./DispatchJobs.vue?vue&type=script&lang=js&"
export * from "./DispatchJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports